<app-navigation-bar></app-navigation-bar>
<router-outlet></router-outlet>

